import React, { useEffect, useState } from 'react';
import { TrialsService } from '../../services/TrialServices';
import TrailsListForModule from '../Trials/TrialsListForModule';

interface InputProps {
    cookId: number
}

const trialsService = new TrialsService();

const CookTrialTab = (props: InputProps) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [subData, setSubData] = useState<any>(null);
    const refreshData = (cookId: number, limit: number, offset: number) => {
        trialsService.getTrialsForCook(cookId, limit, offset, { order: "DESC", field: "id" })
            .then((data) => {
                setSubData(data);
            })
            .catch(() => {})
    }

    useEffect(() => {
        refreshData(props.cookId, rowsPerPage, page * rowsPerPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.cookId, rowsPerPage, page]);

    return (
        <div>
            <TrailsListForModule
                data={subData?.data ?? []}
                page={page}
                rowsPerPage={rowsPerPage}
                total={subData?.total ?? 0}
                onPageChange={setPage}
                onRowsPerPageChange={(rows) => { setRowsPerPage(rows); setPage(0); }}
            />
        </div>
    );
};

export default CookTrialTab;
